import http from "infra/http";
import { useQuery } from "react-query";
import { ParceiroEndereco } from "../typings"


export default function useEndereco(id: string) {
  return useQuery(`/v1/parceiro/${id}/endereco`, async () => {
    const { data } = await http.get<ParceiroEndereco>(`/v1/parceiro/${id}/endereco`);

    return data;
  });
}
